module.exports = __webpack_public_path__ + "media/packs/compcalc/components/images/caaa-b9d9d8b5f0c5d90c47960ea98832633e.png";